import { useTranslation } from 'next-i18next';
import { PlusSmallCircleIcon } from '@/icons';
import { Button } from '@/ui_v3';
export const AddOptionButton = ({
  onClick
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Button variant={'contained'} intent="neutral" size="md" className="w-full" leftSlot={<PlusSmallCircleIcon size="xs" />} onClick={onClick} data-sentry-element="Button" data-sentry-component="AddOptionButton" data-sentry-source-file="AddOptionButton.tsx">
      {t('build.multiple.addChoice')}
    </Button>;
};